import { apiClient } from './api';

export interface InvitationInfo {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  roleLabel: string;
  salonName: string | null;
  status: 'PENDING' | 'ACCEPTED' | 'CANCELLED';
  expired: boolean;
  step: 'password' | 'verify' | 'done' | 'invalid';
}

export interface VerifyResponse {
  user: { id: string; email: string; role: string; isActive: boolean };
  accessToken: string;
  refreshToken: string;
}

export const invitationService = {
  get: (token: string) => apiClient.get<InvitationInfo>(`/invitations/${token}`).then((r) => r.data),
  accept: (token: string, password: string) =>
    apiClient.post<{ email: string }>(`/invitations/${token}/accept`, { password }).then((r) => r.data),
  verify: (token: string, code: string) =>
    apiClient.post<VerifyResponse>('/invitations/verify', { token, code }).then((r) => r.data),
  resendCode: (token: string) =>
    apiClient.post<{ message: string }>('/invitations/resend-code', { token }).then((r) => r.data),
};
